import { Selector, State, StateContext, createSelector } from '@ngxs/store';
import { Receiver } from '@ngxs-labs/emitter';
import { Injectable, Injector } from '@angular/core';
import { ENDPOINTS } from 'src/app/@config';
import { IdNamePair } from 'src/app/@models';
import { DropdownService } from 'src/app/@services';

@State<IdNamePair[]>({
  name: 'leadSource',
  defaults: []
})
@Injectable()
export class LeadSourceState {
  private static dropdownService: DropdownService

  static hasAny() {
    return createSelector([LeadSourceState], (state: IdNamePair[]) => {
      return state?.length > 0;
    });
  }

  @Selector()
  static isEmpty(state: IdNamePair[]): boolean {
    return state.length === 0;
  }

  static getById(id: number) {
    return createSelector([LeadSourceState], (state: IdNamePair[]) => {
      return state.find((x: IdNamePair)=> x.id === id).name;
      
    });
  }

  constructor(injector: Injector) {
    LeadSourceState.dropdownService = injector.get(DropdownService);
  }

  @Receiver()
  static loadAll({ setState }: StateContext<IdNamePair[]>) {
    this.dropdownService.getDropdownData(ENDPOINTS.getLeadSourceList()).subscribe((data: IdNamePair[]) => setState(data));
  }
}
